import classnames from 'classnames'
import { CreditOfferDetails } from 'embed/constants/models'
import * as React from 'react'
import { Accordion } from '../../../../../Accordion'

const styles = require('./styles')

interface DefaultCreditListItemProps {
  details: CreditOfferDetails
  onDetailsRendered: (numberOfDetails: number, numberOfDetailsShown: number) => void
}

const NUMBER_OF_DETAILS_SHOWN = 1

export const CreditListItemDetails = (props: DefaultCreditListItemProps) => {
  const {
    details: { additionalDetails, details },
    onDetailsRendered,
  } = props

  // Offer Details
  const detailsListItems =
    details && details.map((value, key) => <li dangerouslySetInnerHTML={{ __html: value }} key={`details_${key}`} />)

  const additionalDetailsItems =
    additionalDetails &&
    additionalDetails.map((value, key) => (
      <li dangerouslySetInnerHTML={{ __html: value }} key={`additional_details_${key}`} />
    ))

  const allDetails: JSX.Element[] | undefined = additionalDetailsItems
    ? detailsListItems?.concat(additionalDetailsItems)
    : detailsListItems

  React.useEffect(() => {
    onDetailsRendered(allDetails?.length ?? 0, NUMBER_OF_DETAILS_SHOWN)
  }, [])

  return allDetails ? (
    <div className={classnames(styles.creditOfferDetailsContainer)}>
      <span className={styles.detailsLabel}>Card Details</span>
      <div className={classnames(styles.creditOfferDetails)}>
        <div className={classnames(styles.creditOfferDetail)}>
          <Accordion maxHeight={50} collapsed={true}>
            {allDetails}
          </Accordion>
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}
